module.exports = __webpack_public_path__ + "h5/img/PDF6.6ba549c9.jpg";